import { useState } from "react";
import { Link } from "react-router-dom";
import HeroImage1 from "../../images/services/hero-image1.png";
import HeroImage2 from "../../images/services/hero-image2.png";
import HeroImage3 from "../../images/services/hero-image3.png";
import HeroImage4 from "../../images/services/hero-image4.png";
import Vector1 from "../../images/services/vector1.png";
import Vector3 from "../../images/services/vector3.png";
import Grid from "../../images/services/grid.png";

function ServicesHero() {
  const [email, setEmail] = useState("");

  return (
    <div className="services-hero">
      <div className="heading">
        <h1>Simplified Services for Enterprise</h1>
        <h2>
          We focus on making enterprise services less complicated and more
          effective. From system development to ongoing support, our team
          handles what matters—clearly and reliably.
        </h2>
        <div className="contact">
          <input
            type="email"
            placeholder="Your email - We will reach out"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Link to="/contact-us">
            <button>
              <p>Get in touch</p>
              <div />
            </button>
          </Link>
        </div>
      </div>
      <img src={HeroImage1} alt="img" className="image1" />
      <img src={HeroImage2} alt="img" className="image2" />
      <img src={HeroImage3} alt="img" className="image3" />
      <img src={HeroImage4} alt="img" className="image4" />
      <canvas className="shape" />
      <img src={Vector1} alt="vector" className="vector1" />
      <img src={Vector3} alt="vector" className="vector3" />
      <img src={Grid} alt="grid" className="grid" />
    </div>
  );
}

export default ServicesHero;
